// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalFault, NormalFaultT } from "./normal-fault";
import { ValuedFault, ValuedFaultT } from "./valued-fault";

export enum FaultVariant {
  NONE = 0,
  NormalFault = 1,
  ValuedFault = 2,
}

export function unionToFaultVariant(
  type: FaultVariant,
  accessor: (obj: NormalFault | ValuedFault) => NormalFault | ValuedFault | null,
): NormalFault | ValuedFault | null {
  switch (FaultVariant[type]) {
    case "NONE":
      return null;
    case "NormalFault":
      return accessor(new NormalFault())! as NormalFault;
    case "ValuedFault":
      return accessor(new ValuedFault())! as ValuedFault;
    default:
      return null;
  }
}

export function unionListToFaultVariant(
  type: FaultVariant,
  accessor: (index: number, obj: NormalFault | ValuedFault) => NormalFault | ValuedFault | null,
  index: number,
): NormalFault | ValuedFault | null {
  switch (FaultVariant[type]) {
    case "NONE":
      return null;
    case "NormalFault":
      return accessor(index, new NormalFault())! as NormalFault;
    case "ValuedFault":
      return accessor(index, new ValuedFault())! as ValuedFault;
    default:
      return null;
  }
}

export type FaultVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalFault"; value: NormalFaultT }
  | { type: "ValuedFault"; value: ValuedFaultT };
